var helper = {
	toRad: function(deg) {
		return deg * Math.PI/180
	}
}

module.exports = helper;


/** WEBPACK FOOTER **
 ** ./src/helper.js
 **/